<section class="models">
  <h2 id="product-models-title" class="container no-border">Tipos de unidades</h2>

  <div class="model-container" [class.active]="showModels">
    <div class="model-item" *ngFor="let model of data.product_models">

      <figure>
        <img [src]="model.plan_image" alt="Planta baixa" onerror="this.src='/assets/svgs/planta.svg'">
      </figure>

      <div class="description">
        <p>
          {{model.description}} {{model.area}}m²
        </p>
        <ul *ngIf="model.details !== undefined">
          <ng-container *ngFor="let detail of model.details">
            <li *ngIf="detail.value != 0">
              {{detail.name}}
              <span>
                <img src="/assets/svgs/product-details/red/{{detail.type}}.svg" [alt]="detail.name"
                      onerror="this.src='/assets/svgs/product-details/red/default.svg'">
                {{detail.value}}
              </span>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>

  <button id="load-more-models-btn" class="button" (click)="showModels = !showModels"
    *ngIf="data.product_models.length > 3">
    Carregar mais unidades
  </button>

</section>